import { LOCATION_CHANGE } from 'react-router-redux';
import * as TYPES from '../../constants/types';

const initialState = {
  data: [],
  pagination: {
    total_pages: 1,
  },
  currentPage: 1,
  divisionId: null,
  loading: false,
  loaded: false,
  error: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case TYPES.GET_DIVISION_MEDICS_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
      };

    case TYPES.GET_DIVISION_MEDICS_SUCCESS:
      return {
        ...state,
        data: action.payload.response.data,
        pagination: action.payload.response.pagination,
        currentPage: action.payload.page,
        divisionId: action.payload.divisionId,
        loading: false,
        loaded: true,
      };

    case TYPES.GET_DIVISION_MEDICS_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
        currentPage: action.payload.page,
        error: action.payload.error,
      };

    case LOCATION_CHANGE: {
      return initialState;
    }

    default:
      return state;
  }
}
